
import { useCharacterColorThemes } from "@/hooks/useCharacterColorThemes";
import { generateGradientColors } from "@/utils/colorUtils";

export interface EnhancedColorTheme {
  id: string;
  name: string;
  baseColor: string;
  gradientColors: {
    from: string;
    to: string;
  };
  is_active: boolean;
  display_order: number;
}

export const useEnhancedColorThemes = () => {
  const { colorThemes, isLoading, error, ...mutations } = useCharacterColorThemes();

  const enhancedColorThemes: EnhancedColorTheme[] = colorThemes.map(theme => ({
    id: theme.id,
    name: theme.name,
    baseColor: theme.color_hex || '#0EA5E9',
    gradientColors: generateGradientColors(theme.color_hex || '#0EA5E9'),
    is_active: theme.is_active,
    display_order: theme.display_order,
  }));

  const getEnhancedTheme = (themeName: string): EnhancedColorTheme => {
    const theme = enhancedColorThemes.find(ct => 
      ct.name.toLowerCase() === themeName?.toLowerCase()
    );
    
    if (!theme) {
      // Default theme if not found
      const defaultColor = '#0EA5E9';
      return {
        id: 'default',
        name: 'default',
        baseColor: defaultColor,
        gradientColors: generateGradientColors(defaultColor),
        is_active: true,
        display_order: 0,
      };
    }
    
    return theme;
  };

  return {
    colorThemes: enhancedColorThemes,
    isLoading,
    error,
    getEnhancedTheme,
    ...mutations
  };
};
